import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [societes, setSocietes] = useState([]);
  const [societeId, setSocieteId] = useState(localStorage.getItem("gf_societe") || "all");
  const [exercice, setExercice] = useState(localStorage.getItem("gf_exercice") || "2026");
  const annees = ["2026", "2025"];

  const loadSocietes = useCallback(async () => {
    try {
      const { data } = await api.get("/societes");
      setSocietes(data);
    } catch (e) {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    loadSocietes();
  }, [loadSocietes]);

  const selectSociete = (id) => {
    setSocieteId(id);
    localStorage.setItem("gf_societe", id);
  };

  const selectExercice = (y) => {
    setExercice(y);
    localStorage.setItem("gf_exercice", y);
    window.location.reload();
  };

  const societeParam = societeId && societeId !== "all" ? { societe_id: societeId } : {};

  return (
    <AppContext.Provider
      value={{ societes, societeId, selectSociete, societeParam, loadSocietes, exercice, selectExercice, annees }}
    >
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
